export default __webpack_public_path__ + "static/media/wetez_validator_market.214001a1.png";